import { useState, useEffect, useRef } from 'react';
import { Input } from '@/components/ui/input';

function formatWithCommas(val) {
  if (!val && val !== 0) return '';
  const str = String(val).replace(/[^0-9.]/g, '');
  const parts = str.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

function stripCommas(str) {
  return String(str).replace(/,/g, '');
}

export function MoneyInput({ value, onChange, className, placeholder, ...props }) {
  const [display, setDisplay] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    const num = parseFloat(value);
    if (!isNaN(num) && num !== 0) {
      setDisplay(formatWithCommas(value));
    } else if (value === '' || value === null || value === undefined) {
      setDisplay('');
    }
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^0-9.,]/g, '');
    const clean = stripCommas(raw);
    setDisplay(formatWithCommas(clean));
    const num = parseFloat(clean);
    onChange(isNaN(num) ? 0 : num);
  };

  return (
    <Input
      ref={inputRef}
      type="text"
      inputMode="numeric"
      value={display}
      onChange={handleChange}
      className={className}
      placeholder={placeholder || '0'}
      {...props}
    />
  );
}
